import * as React from 'react';
import styled from 'styled-components';
import { darken } from 'polished';
import { colors } from '../styles/variables'
import Button from '../Shared/Button';

const ModalView = styled.div`
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translate3d(0,100vh,0);
  background-color: rgba(0,0,0,0.8);
  transition: all 0.2s ease-in-out;
  &.active {
    transform: translate3d(0,0,0);
  }
  & > .inner {
    background-color: ${colors.white};
    max-width: 800px;
    margin: 60px auto;
    .footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0.25rem 0.5rem;
      min-height: 60px;
    }
    .button {
      transition: all 0.2s ease-in-out;
      background-color: ${colors.red};
      padding: 0.5rem 1rem;
      border: none;
      border-radius: 4px;
      color: ${colors.white};
      text-decoration: none;
      min-width: 100px;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: ${darken(0.05, colors.red)};
        color: ${colors.white};
        text-decoration: none;
      }
    }
  }
`;

interface IModal {
  isShown: boolean,
  handleClose: () => void,
}

const Modal: React.FC<IModal> = (props) => {
  const { isShown, handleClose } = props;
  function handleBackdropClick(event: React.MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.currentTarget === event.target) {
      // 最も外枠（Backdrop）をクリックした場合はモーダルを閉じる
      handleClose();
    }
  }
  return (
    <ModalView className={isShown ? 'active' : null} onClick={handleBackdropClick}>
      <div className="inner">
        {props.children}
        <div className="footer">
          <div>
            <Button href="#" onClick={handleClose}>
              OK
            </Button>
          </div>
        </div>
      </div>
    </ModalView>
  );
};

export default Modal;
